<template>
  <div>
    <el-overlay-loading :loading="loading" />
    <!--  -->
    <el-text-field
      :disabled="updatingAdded"
      hide-details
      label="Paieška"
      v-model="search"
      @input="resetSearchTimer()"
    />
    <composite-list
      label="Paslaugos, kurias galima pridėti"
      :items="items"
      v-model="filteredItems"
      :disabled="disabled"
      @action-item="addItem"
      @action-all="checkAddItems"
      :updating="updating"
    />
    <!-- added -->
    <el-text-field
      :disabled="updating"
      hide-details
      label="Paieška"
      v-model="addedSearch"
      @input="resetSearchAddedTimer()"
    />
    <composite-list
      label="Pridėtos paslaugos"
      :items="items"
      v-model="filteredAddedItems"
      :disabled="disabled"
      added
      @action-item="deleteItem"
      @action-all="checkdDeleteItems"
      :updating="updatingAdded"
    />
    <!--  -->
  </div>
</template>

<script>
import CompositeList from './CompositeList.vue'
import { transliterate as tr } from 'transliteration'
export default {
  name: 'ElCompositeListSelect',
  components: { CompositeList },
  mixins: [],
  props: {
    label: String,
    subLabel: String,
    items: [Object, Array],
    itemtext: String,
    itemvalue: String,
    value: [String, Number, Object, Array, Boolean],
    disabled: Boolean,
    validateKey: String,
  },
  data() {
    return {
      searchTimer: null,
      search: '',
      activeSearch: '',
      addedSearch: '',
      activeAddedSearch: '',
      loading: false,
      updating: false,
      updatingAdded: false,
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    filteredAddedItems() {
      const queryText = this.activeAddedSearch
      if (!queryText) {
        this.changeUpdate(true)
        return this.elValue
      }

      const ltElementsMap = {}
      this.items.lt.forEach((element) => {
        ltElementsMap[element.value] = element
      })

      const ans = this.elValue.filter((item) => {
        const ltElement = ltElementsMap[item]
        return ltElement && this.searchInFragments(ltElement, queryText)
      })

      this.changeUpdate(true)
      return ans
    },
    filteredItems() {
      const queryText = this.activeSearch
      if (!queryText) {
        this.changeUpdate()
        return this.getItems && this.getItems.lt
      }
      let ans = this.getItems.lt.filter((item) =>
        this.searchInFragments(item, queryText)
      )
      this.changeUpdate()
      return ans
    },
    getId() {
      return this.$route.params.id || null
    },
    getItems() {
      this.elValue
      if (this.items && this.elValue) {
        let list = {}
        list.lt = this.items.lt.filter(
          (item) => !this.elValue.includes(item.value)
        )
        return list
      }
      return this.items
    },
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
  created() {},
  methods: {
    changeUpdate(added) {
      if (added) {
        this.updatingAdded = false
      } else {
        this.updating = false
      }
    },
    searchInFragments(item, queryText) {
      let logicArr = []
      queryText.split(' ').map((fragment) => {
        if (fragment == '') {
          return
        }
        let logic =
          tr(item.text).toLowerCase().includes(tr(fragment).toLowerCase()) ||
          tr(this.$i18n.locale === 'lt' ? item.title_lt : item.title_en)
            .toLowerCase()
            .includes(tr(fragment).toLowerCase())
        logicArr.push(logic)
      })
      return logicArr.every((element) => element)
    },
    resetSearchTimer() {
      this.updating = true
      if (this.activeSearch == this.search) {
        this.updating = false
      }
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.updating = true
        if (this.activeSearch == this.search) {
          this.updating = false
        }
      }, 2900)
      this.searchTimer = setTimeout(() => {
        this.activeSearch = this.search
      }, 3000)
    },
    resetSearchAddedTimer() {
      this.updatingAdded = true
      if (this.activeAddedSearch == this.addedSearch) {
        this.updatingAdded = false
      }
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.updatingAdded = true
        if (this.activeAddedSearch == this.addedSearch) {
          this.updatingAdded = false
        }
      }, 2900)
      this.searchTimer = setTimeout(() => {
        this.activeAddedSearch = this.addedSearch
      }, 3000)
    },
    addItem(item) {
      let arr = []
      arr.push(item.value)
      this.addItems(arr, true)
    },
    deleteItem(item) {
      let arr = []
      arr.push(item)
      this.deleteItems(arr, true)
    },
    async checkAddItems(items) {
      const chunkSize = 500
      const itemChunks = []
      for (let i = 0; i < items.length; i += chunkSize) {
        const chunk = items.slice(i, i + chunkSize)
        itemChunks.push(chunk)
      }
      try {
        for (let i = 0; i < itemChunks.length; i++) {
          const chunk = itemChunks[i]
          const isLastChunk = i === itemChunks.length - 1
          // if((i + 1) % 5 === 0){
          await this.addItems(chunk, isLastChunk)
          // } else {
          // this.addItems(chunk, isLastChunk)
          // }
        }
      } catch (error) {
        return
      }
    },
    async checkdDeleteItems(items) {
      const chunkSize = 500
      const itemChunks = []
      for (let i = 0; i < items.length; i += chunkSize) {
        const chunk = items.slice(i, i + chunkSize)
        itemChunks.push(chunk)
      }
      try {
        for (let i = 0; i < itemChunks.length; i++) {
          const chunk = itemChunks[i]
          const isLastChunk = i === itemChunks.length - 1
          // if((i + 1) % 5 === 0){
          await this.deleteItems(chunk, isLastChunk)
          // } else {
          // this.deleteItems(chunk, isLastChunk)
          // }
        }
      } catch (error) {
        return
      }
    },
    async addItems(items, final) {
      this.loading = true
      let data = {
        actions: items,
      }
      await this.$axios
        .post(`nirvar/${this.getId}/add-action`, data)
        .then((res) => {
          if (final) {
            this.updateData()
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          throw 'Failed to add items'
        })
        .finally(() => {
          this.loading = false
        })
    },
    async deleteItems(items, final) {
      this.loading = true
      let data = {
        actions: items,
      }
      await this.$axios
        .post(`nirvar/${this.getId}/remove-action`, data)
        .then((res) => {
          if (final) {
            this.updateData()
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          throw 'Failed to delete items'
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateData() {
      this.$emit('update-data')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
